let currentHandler = null

const clickHandlerService = {
    registerClickHandler: handler => {
        currentHandler = handler
    },
    getClickHandler: () => currentHandler
}

export default clickHandlerService
